
import { defineComponent } from "vue";
import HomeComponent from "@/components/HomeComponent.vue";
import MediaComponent from "@/components/MediaComponent.vue";
import PlumberComponent from "@/components/PlumberComponent.vue";
import UpcomingComponent from "@/components/UpcomingComponent.vue";
import CommunityComponent from "@/components/CommunityComponent.vue";

export default defineComponent({
  name: "MainView",
  components: {
    homeComponent: HomeComponent,
    mediaComponent: MediaComponent,
    plumberComponent: PlumberComponent,
    upcomingComponent: UpcomingComponent,
    communityComponent: CommunityComponent,
  },
});
